import { render } from "./CloseModalButton.vue?vue&type=template&id=4f1c9c56&ts=true"
import script from "./CloseModalButton.vue?vue&type=script&lang=ts"
export * from "./CloseModalButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__